import { useAppDispatch, useAppSelector } from "@app/store";
import { useUserId } from "@hooks/use-user-id";
import { useCallback } from "react";
import { TransferMoneyForm } from "./api";
import {
  getAssignWallet,
  getBalances,
  getSaveFrozenBalance,
  getUsdtPrice,
  transferMoney,
} from "./slice";

export const useBalance = () => {
  const state = useAppSelector((state) => state.balance);

  const { getBalances, getSaveFrozenBalance, ...methods } =
    useBalanceDispatch();

  return {
    state,
    getBalances,
    getSaveFrozenBalance,
    ...methods,
  };
};

export const useBalanceDispatch = () => {
  const userId = useUserId();
  const dispatch = useAppDispatch();

  const getBalancesHandler = useCallback(
    () => dispatch(getBalances(userId)),
    [dispatch, userId]
  );

  const getSaveFrozenBalanceHandler = useCallback(
    () => dispatch(getSaveFrozenBalance(userId)),
    [dispatch, userId]
  );

  const transferMoneyHandler = useCallback(
    (data: Omit<TransferMoneyForm, "user_id">) =>
      dispatch(transferMoney({ ...data, user_id: userId })).unwrap(),
    [dispatch, userId]
  );

  const getAssignWalletHandler = useCallback(
    () => dispatch(getAssignWallet(userId)).unwrap(),
    [dispatch, userId]
  );

  const getUsdtPriceHandler = useCallback(
    () => dispatch(getUsdtPrice()).unwrap(),
    [dispatch]
  );

  return {
    getBalances: getBalancesHandler,
    getSaveFrozenBalance: getSaveFrozenBalanceHandler,
    getAssignWallet: getAssignWalletHandler,
    transferMoney: transferMoneyHandler,
    getUsdtPrice: getUsdtPriceHandler,
  };
};
